const DELIMITER = ".";
/**
 * Flatten object to a simple key value object
 */
export function flattenObject(source: object, delimiter = DELIMITER) {
    const result: Record<string, string> = {};
    const flattenFn = (_source: object, prefix = "") => {
        const _prefix = prefix === "" ? prefix : `${prefix}${delimiter}`;
        return Object.keys(_source).forEach((c) => {
            const value: string | object = _source[c as keyof typeof _source];
            const key = `${_prefix}${c}`;
            if (typeof value === "string") {
                result[key] = value;
            } else {
                flattenFn(value, key);
            }
        });
    };
    flattenFn(source);
    return result;
}
